<template>
  <div
    class="w-full flex flex-col relative"
    :class="{'gap-3': isMobileOpen || (isOpen && !has('archive')) }"
  >
    <div class="block lg:hidden w-full">
      <button
        class="relative btn btn-red w-full flex flex-row justify-center items-center"
        @click="isMobileOpen = !isMobileOpen"
      >
        Kereső
        <img
          src="/img/icons/inputs/dropdown_arrow_icon.svg"
          class="h-[16px] w-[16px] absolute right-4 top-4 transform transition-all group-hover:text-gray-darkest duration-500 "
          :class="{ 
            'rotate-180': isMobileOpen,
          }"
        >
      </button>
    </div>

    <div 
      :class="{ 'max-h-[2000px] opacity-100': isMobileOpen}"
      class="w-full flex flex-col lg:flex-row gap-3 max-h-0 lg:max-h-full transition-all duration-500 opacity-0 lg:opacity-100"
    >
      <div
        class="flex flex-col w-full lg:w-1/3"
      >
        <ReMonthPicker
          v-if="has('month-picker')"
          v-model="selectedMonth"
          :has-errors="false"
          icon="/img/calendar_icon.svg"
        />
        <ReDateRange
          v-if="has('date-picker')"
          v-model="selectedDays"
          :has-errors="false"
          icon="/img/calendar_icon.svg"
        />
        <ReCheckbox
          v-if="has('archive')"
          v-model="form.history"
          :has-errors="false"
          type="left"
        >
          Keresés a korábbi programok között is
        </ReCheckbox>
      </div>
      <ReInput
        v-if="has('text')"
        id="searchtext"
        v-model="form.text"
        placeholder="Keresendő szöveg"
        :has-errors="false"
        type="text"
        class="w-full lg:w-1/3"
        icon="/img/pen_icon.svg"
      />
      <div class="w-full lg:w-1/3 flex flex-col lg:flex-row gap-3">
        <div class="w-full lg:w-3/12 order-1 lg:order-none">
          <button
            type="button"
            title="Keresés"
            class="btn btn-red w-full"
            @click.prevent="submit"
          >
            <i class="fas fa-search" />
          </button>
        </div>
        <div class="w-full lg:w-5/12 flex align-center h-12 place-content-center order-3 lg:order-none">
          <button
            type="button"
            class="text-lg group text-red"
            @click="isOpen = !isOpen"
          >
            <span
              v-if="!isOpen"
              title="Részletes kereső megjelenítése"
              class="m-0 p-0"
            >Részletes kereső </span><i
              v-if="!isOpen"
              class="fas fa-arrow-down place-self-center text-yellow group-hover:text-red-light block"
            />
            <span
              v-if="isOpen"
              class="m-0 p-0"
              title="Részletes kereső bezárása"
            >Kereső bezárása </span><i
              v-if="isOpen"
              class="fas fa-times  place-self-center text-yellow group-hover:text-red-light block"
            />
          </button>
        </div>
        <div class="hidden lg:block lg:w-4/12 order-2 lg:order-none">
          <nuxt-link
            v-if="!loggedIn()"
            to="/belepes"
            class="btn btn-yellow"
          >
            Új esemény
          </nuxt-link>
          <nuxt-link
            v-else
            to="/fiokom/esemeny"
            class="btn btn-yellow"
          >
            Új esemény
          </nuxt-link>
        </div>
      </div>
    </div>
    <div
      :class="{ 'max-h-[2000px] opacity-100': isOpen}"
      class="w-full flex flex-col lg:flex-row gap-3 max-h-0 transition-all duration-500 opacity-0"
    >
      <ReSelect
        v-model="form.country"
        :items="countries"
        :has-errors="false"
        multiple
        has-filter
        placeholder="Ország"
        class="w-full lg:w-1/3"
      />
      <ReSelect
        v-model="form.city"
        :items="cities"
        multiple
        has-filter
        :has-errors="false"
        placeholder="Település"
        class="w-full lg:w-1/3"
      />
      <ReSelect
        v-model="form.tags"
        :items="tags"
        :has-errors="false"
        multiple
        has-filter
        placeholder="Kategória"
        class="w-full lg:w-1/3"
      />
    </div>    
  </div>
</template>
<script>
import { DateTime } from "luxon";
import ReInput from "~/components/rxt/reform/ReInput.vue";
import ReSelect from "~/components/rxt/reform/ReSelect.vue";
import ReCheckbox from "~/components/rxt/reform/ReCheckbox.vue";
import ReDateRange from "~/components/rxt/reform/ReDateRange";
import ReMonthPicker from "~/components/rxt/reform/ReMonthPicker.vue";

export default {
  components: {
    ReInput,
    ReSelect,
    ReCheckbox,
    ReDateRange,
    ReMonthPicker
  },
  props: {
    modules: {
      type: Array,
      default: () => {
        return ["date-picker", "text", "city", "tags", "archive", "country"];
      }
    },
    queryObject: {
      type: Object,
      required: true
    },
    propMapping: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showNav: false,
      selectedDays: { from: null, to: null },
      selectedMonth: "",
      form: {
        date: null,
        text: "",
        city: [],
        country: [],
        tags: [],
        history: false
      },
      isMobileOpen: false,
      isOpen: false
    };
  },
  computed: {
    cities() {
      const cities = this.form.history
        ? this.$store.state.cities
        : this.$store.state.citiesActual;
      return cities
        .filter(item => {
          return !this.form.country.length
            ? true
            : this.form.country.includes(item.country);
        })
        .map(item => {
          return {
            key: item.city,
            value: item.city,
            text: item.city
          };
        });
    },
    countries() {
      const countries = this.form.history
        ? this.$store.state.countries
        : this.$store.state.countriesActual;
      return countries.map(item => {
        return {
          key: item.country,
          value: item.country,
          text: item.country
        };
      });
    },
    tags() {
      return this.$store.state.eventTypes.map(item => {
        return {
          key: item.type,
          value: item.type,
          text: item.type
        };
      });
    }
  },
  watch: {
    "selectedDays.from"() {
      if(this.selectedDays.from){
        const today = new Date();
        const tempDate = new Date(this.selectedDays.from);
        if (this.$moment(tempDate).isBefore(this.$moment(today))) {
          this.form.history = true;
        } else {
          this.form.history = false;
        }
      } else {
        this.form.history = false;
      }
    },
    queryObject: {
      handler(newData) {
        this.makeFormObjectFromQueryObject(newData);
      },
      deep: true
    }
  },
  async fetch(){
    this.makeFormObjectFromQueryObject(this.queryObject);
    await Promise.all([
      this.$store.dispatch("loadEventTypes"),
      this.$store.dispatch("loadCities"),
      this.$store.dispatch("loadCountires"),
      this.$store.dispatch("loadCitiesActual"),
      this.$store.dispatch("loadCountriesActual")
    ])
  },
  methods: {
    makeFormObjectFromQueryObject(newData) {
      const form = {
        date: null,
        text: "",
        city: [],
        country: [],
        tags: [],
        history: false
      };

      // set form params for eventsearch component
      if (newData["filter[between]"]) {
        if (!this.has("month-picker")) {
          const split = decodeURIComponent(newData["filter[between]"]).split(
            ":"
          );
          form.date = [];
          this.selectedDays.from = form.date[0] = split[0];
          this.selectedDays.to = form.date[1] = split[1];
        } else {
          form.date = newData["filter[between]"].split(":")[0];
          this.selectedMonth = form.date;
        }
      } else {
        this.selectedDays = {
          from: null,
          to: null
        };
      }

      if (newData["filter[city]"]) {
        this.isOpen = true;
        form.city = newData["filter[city]"].split(",");
      }
      if (newData["filter[country]"]) {
        this.isOpen = true;
        form.country = newData["filter[country]"].split(",");
      }
      if (newData["filter[type]"]) {
        this.isOpen = true;
        form.tags = newData["filter[type]"].split(",");
      }

      if (this.has("archive")) {
        form.history =
          newData["filter[history]"] !== undefined
            ? newData["filter[history]"] === "true"
            : false;
      } else {
        form.history = true;
      }
      form.text = newData["filter[search]"] ? newData["filter[search]"] : "";

      this.form = form;
    },
    submit() {
      const queryObject = {};

      if (this.form.text && this.form.text.length > 0) {
        queryObject["filter[search]"] = this.form.text;
      }
      if (this.form.city.length > 0) {
        queryObject["filter[city]"] = this.form.city.join(",");
      }
      if (this.form.country.length > 0) {
        queryObject["filter[country]"] = this.form.country.join(",");
      }
      if (this.form.tags.length > 0) {
        queryObject["filter[type]"] = this.form.tags.join(",");
      }
      if (this.selectedDays.from !== null) {
        this.form.date = [];
        this.form.date.push(this.selectedDays.from);
        this.form.date.push(this.selectedDays.to);
      } else if (this.selectedMonth !== "") {
        this.form.date = this.selectedMonth;
      } else {
        this.form.date = null;
      }

      if (this.form.date !== null) {
        if (this.form.date.length === 2) {
          if (!this.form.date[1]) {
            this.form.date[1] = this.form.date[0];
          }
          queryObject["filter[between]"] =
            this.$moment(this.form.date[0]).format("YYYY-MM-DD") +
            ":" +
            this.$moment(this.form.date[1]).format("YYYY-MM-DD");
        } else {
          queryObject["filter[between]"] =
            DateTime.fromISO(this.form.date).startOf('month').toFormat("yyyy-MM-dd") +
              ":" +
            DateTime.fromISO(this.form.date).endOf("month").toFormat("yyyy-MM-dd");
        }
      } else {
        delete queryObject["filter[between]"];
      }

      if (this.has("archive")) {
        queryObject["filter[history]"] = this.form.history;
      } else {
        queryObject["filter[history]"] = true;
      }

      this.$emit("searchChanged", queryObject);
      this.showNav = false;
    },
    has(name) {
      return this.modules.includes(name);
    },
    calculateOffset() {
      return this.modules.length * 5;
    },
    changeFormDate(date) {
      if (date.length === 1) {
        this.form.date = date[0];
        this.selectedMonth = date[0];
      } else {
        this.form.date = date;
        this.selectedDays = date;
      }
    }
  }
};
</script>
